import COLORS from '@/constants/colors';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Typography } from '@mui/material';
import { DetailActions } from '../OrderDetailActions/DetailActions';
import { useHeaderViewController } from './HeaderViewController';

export function Header() {
  const { uiState, actions } = useHeaderViewController();

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          cursor: 'pointer',
          width: 'fit-content',
          p: { xs: '16px', md: '0px' },
        }}
        onClick={actions.handleReturnClick}
      >
        <ArrowBackIcon sx={{ color: COLORS.green }} />
        <Typography
          sx={{
            fontSize: { xs: '12px', md: '14px' },
            fontWeight: 500,
            color: COLORS.olive,
          }}
        >
          Regresar
        </Typography>
      </Box>
      <Box
        sx={{
          display: { xs: 'inline-block', sm: 'inline-flex' },
          gap: '15px',
          placeItems: 'center',
          width: '100%',
          placeContent: 'space-between',
          px: { xs: '16px', md: '0px' },
        }}
      >
        <Box
          sx={{
            display: 'block',
            alignItems: 'center',
            gap: '8px',
            paddingBottom: { xs: '15px', sm: '0px' },
            paddingTop: '15px',
            justifySelf: 'left',
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: '18px', md: '30px' },
              fontWeight: '500',
              color: COLORS.mercanto_blue,
            }}
          >
            Detalles del pedido
          </Typography>
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: '400',
              color: COLORS.gray_600,
            }}
          >
            #{uiState.orderNumber}
          </Typography>
        </Box>
        <DetailActions />
      </Box>
    </>
  );
}
